<template>
    <div class="k-divider"></div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
.k-divider {
    margin-bottom: 20px;

    @include media-breakpoint-up(lg) {
        margin-bottom: 60px;
    }
}
</style>
